// @flow
export { default } from './BrandContent';



// WEBPACK FOOTER //
// ./src/components/brand/BrandContent/index.js